/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkDmReadResponse
 */
export interface MarkDmReadResponse {
    /**
     * Number of messages marked as read
     * @type {number}
     * @memberof MarkDmReadResponse
     */
    updated: number;
}

/**
 * Check if a given object implements the MarkDmReadResponse interface.
 */
export function instanceOfMarkDmReadResponse(value: object): value is MarkDmReadResponse {
    if (!('updated' in value) || value['updated'] === undefined) return false;
    return true;
}

export function MarkDmReadResponseFromJSON(json: any): MarkDmReadResponse {
    return MarkDmReadResponseFromJSONTyped(json, false);
}

export function MarkDmReadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkDmReadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'updated': json['updated'],
    };
}

export function MarkDmReadResponseToJSON(json: any): MarkDmReadResponse {
    return MarkDmReadResponseToJSONTyped(json, false);
}

export function MarkDmReadResponseToJSONTyped(value?: MarkDmReadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updated': value['updated'],
    };
}

